import { NavTreeItem } from "../../../../components/common/navigation";
import { useTranslation } from "../../../../hooks/useTranslation";
import { UserRole } from "../../../../models/user.model";

const ALL_ROLES: UserRole[] = [UserRole.User, UserRole.Manager, UserRole.Admin];

// Static-content topic — no backend data, so this is a single leaf NavTreeItem
// with no children, same shape as the other static-content FAQ topics.
export const useWorkVsProjectExperienceFaqTree = (): NavTreeItem | null => {
    const { t } = useTranslation();

    return {
        id: "work-vs-project-experience",
        label: t("FAQ_TOPIC_WORK_VS_PROJECT_EXPERIENCE", undefined, "Work Experience vs Project Experience"),
        path: "work-vs-project-experience",
        requiredRoles: ALL_ROLES,
    };
};
